import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'
import useInvoice from '@hooks/useInvoice'

import type { CampaignModel } from '@models/types'

import InvoiceImage from '../../assets/invoice.svg'

const AddInvoiceButton = (props: { campaign: CampaignModel }) => {
  const { campaign } = props

  const invoice = {
    campaign_id: campaign.id,
    created_by: 'creditor',
    creditor_id: campaign.agency_id,
    creditor_type: 'Agency',
  }

  const { callbacks: { createOrEditInvoice } } = useInvoice(invoice)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        padding: 'large',
      }}
      onClick={() => createOrEditInvoice()}
      forceBottomBorder
      showAngleIcon
    >
      <Image backgroundSize="contain" url={InvoiceImage} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>New Invoice</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Create an invoice for your client</Text>
      </Box>
    </ListItem>
  )
}
export default AddInvoiceButton
